import React from 'react';
import axios from 'axios';
import Link from 'next/link';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import classNames from 'classnames';
import {withRouter} from 'next/router';

import {getRouteUrl} from '@utils/functions';
import styles from '@styles/common/Footer.module.scss';

// import Newsletter from './Newsletter';
import CountrySelection from './CountrySelection';

const BannerSlider = dynamic(() => import('@components/bannerSlider/index'));
class Footer extends React.PureComponent {
	state = {
		pageUrl: '',
		ipAddress: '',
		country: '',
	};
	async componentDidMount() {
		this.setPageUrl();
	}
	async componentDidUpdate(prevProps) {
		if (this.props.router.asPath !== prevProps.router.asPath) {
			this.setPageUrl();
		}
	}

	getIPInfo = async () => {
		try {
			const res = await axios.get(
				'https://geolocation-db.com/json/' + process.env.MIX_IP_ADDRESS_KEY,
			);
			return res ? res.data : {};
		} catch (err) {
			return '';
		}
	};

	setPageUrl = async () => {
		const pageUrl = getRouteUrl(this.props.router.asPath);
		const info = await this.getIPInfo();
		this.setState({
			pageUrl,
			ipAddress: info?.IPv4,
			country: info.country_code || 'AU',
		});
	};

	componentDidMount() {
		const script = document.createElement('script');
		script.src = 'https://js.hsforms.net/forms/shell.js';
		document.body.appendChild(script);

		script.addEventListener('load', () => {
			if (window.hbspt) {
				window.hbspt.forms.create({
					region: 'na1',
					portalId: '47537090',
					formId: '0e8c8bd6-1572-4258-b0b5-5634913878d8',
					target: '#hubspotFormSubscribe',
					onFormReady: form => {
						this.customizeHubSpotForm(form);
					},
				});
			}
		});
	}

	customizeHubSpotForm = form => {
		form.querySelectorAll('label').forEach(label => label.remove());

		const emailInput = form.querySelector('input[type="email"]');
		if (emailInput) {
			emailInput.placeholder = 'Enter email address';
			emailInput.style.width = '60%';
			emailInput.style.display = 'block';
			emailInput.style.borderRadius = '8px';
		}

		const submitButton = form.querySelector('input[type="submit"]');
		if (submitButton) {
			submitButton.value = 'Subscribe';
			submitButton.style.backgroundColor = '#99C8CC';
			submitButton.style.border = 'none';
			submitButton.style.marginTop = '10px';
			submitButton.style.borderRadius = '8px';
			submitButton.style.padding = '10px 7px';
			submitButton.style.fontSize = '.9rem';
		}

		const viralityLink = form.querySelector('.hs-form__virality-link');
		if (viralityLink) viralityLink.remove();

		const inputContainer = document.createElement('div');
		inputContainer.className = styles.inputContainer;
		emailInput.parentNode.insertBefore(inputContainer, emailInput);
		inputContainer.appendChild(emailInput);
		inputContainer.appendChild(submitButton);

		form.classList.add(styles.customHubspotForm);
	};

	render() {
		return (
			<>
				{this.state.pageUrl && this.state.pageUrl === 'all-stores' && (
					<BannerSlider types={'footer'}></BannerSlider>
				)}
				<footer className={styles.footer}>
					<div className={styles.container}>
						{/* <Newsletter styles={styles} ipAddress={this.state.ipAddress} /> */}
						<div className={styles.ftMedial}>
							<div className='row'>
								<div className='col-12 col-md-3'>
									<div className={styles.footerAboutUs}>
										<div className={styles.ftLogo}>
											<Image
												alt='Ditybit'
												src='/img/main-logo.png'
												height='132'
												width='252'
												objectFit='contain'
											/>
										</div>
										<div>
											<p
												style={{
													color: '#ffff',
													fontSize: '1.2rem',
													marginBottom: '20px',
												}}
											>
												Newsletter
											</p>
											<div>
												<div
													className={styles.contactForm}
													id='hubspotFormSubscribe'
												></div>
											</div>
										</div>
										<div
											className={classNames(
												styles.footerLinks,
												styles.socialLinks,
											)}
										>
											{/* <ul className='d-flex'>
												<li>
													<Link href='https://www.facebook.com/shopbetterthat/?ref=aymt_homepage_panel&eid=ARCS2dVNbPHPcEQmlnzeGFwPclgfpkivg5y2RJPDVFXinaF6aG5GcugGTg_jwqSzfppuh1nlhsmHisWQ'>
														<a target='_blank'>
															<i className='fab fa-facebook-f'></i>
														</a>
													</Link>
												</li>
												<li>
													<Link href='https://www.instagram.com/better.that/?hl=en'>
														<a target='_blank'>
															<i className='fab fa-instagram'></i>
														</a>
													</Link>
												</li>
											</ul> */}
										</div>
									</div>
								</div>

								<div className='col-6 col-md-3'>
									<div className={styles.footerLinks}>
										<h5>
											Join us
											{/* <span>.</span> */}
										</h5>
										<ul>
											{/*<li>*/}
											{/*	<Link href='/sell'>Sell with us</Link>*/}
											{/*</li>*/}
											<li>
												<Link href='/give'>Nominate a good cause</Link>
											</li>
											{/*<li>*/}
											{/*	<Link href='/blog'>Blog</Link>*/}
											{/*</li>*/}
										</ul>
									</div>
								</div>
								<div className='col-6 col-md-3'>
									<div className={styles.footerLinks}>
										<h5>
											Useful Links
											{/* <span>.</span> */}
										</h5>
										<ul>
											<li>
												<Link href={`/retailers`}>Sell With Us</Link>
											</li>

											<li>
												<Link href='/returns'>Returns</Link>
											</li>
											<li>
												<Link
													href='/pdf/ditybit_buyers_condition.pdf'
													target='_blank'
												>
													Terms & Conditions
												</Link>
											</li>
											<li>
												<Link href='/privacy-policy'>Privacy Policy</Link>
												<Link
													href='/pdf/ditybit_privacy_policy.pdf'
													target='_blank'
												>
													(PDF)
												</Link>
											</li>
											<li>
												<Link href='/contact'>Contact</Link>
											</li>
										</ul>
									</div>
								</div>
								<div
									className={classNames(styles.countrySelectionBox, 'ml-auto')}
								>
									<CountrySelection />
								</div>
							</div>
						</div>

						<div
							className={classNames(
								styles.bottomFooter,
								'd-md-flex align-items-center justify-content-between',
							)}
						>
							<p>
								&copy; {new Date().getFullYear()} Copyright © DITYBIT Drop
								Auctions 2024. All Rights Reserved
							</p>

							<div className={styles.socialIcons}>
								<h5 className='text-white h6 font-weight-bold'>
									Stay Connected
								</h5>
								<ul
									className='d-flex align-items-center gap-2'
									style={{
										gap: '10px',
									}}
								>
									<li>
										<Link
											href='https://www.facebook.com/shopbetterthat/?ref=aymt_homepage_panel&eid=ARCS2dVNbPHPcEQmlnzeGFwPclgfpkivg5y2RJPDVFXinaF6aG5GcugGTg_jwqSzfppuh1nlhsmHisWQ'
											target='_blank'
											className='text-white'
										>
											<i className='fab fa-twitter'></i>
										</Link>
									</li>
									<li>
										<Link
											href='https://www.facebook.com/shopbetterthat/?ref=aymt_homepage_panel&eid=ARCS2dVNbPHPcEQmlnzeGFwPclgfpkivg5y2RJPDVFXinaF6aG5GcugGTg_jwqSzfppuh1nlhsmHisWQ'
											target='_blank'
											className='text-white'
										>
											<i className='fab fa-facebook-f'></i>
										</Link>
									</li>
									<li>
										<Link
											href='https://www.instagram.com/better.that/?hl=en'
											target='_blank'
											className='text-white'
										>
											<i className='fab fa-instagram'></i>
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</footer>
			</>
		);
	}
}

export default withRouter(Footer);
